import controller from './bank-secrecy-declaration-modal.controller';

export default function (app) {
	app.component('bankSecrecyDeclarationModal', {
		templateUrl: 'common/bank-secrecy-declaration-modal',
		bindings: {
			 logout: '&',
			 showLoader: '&',
			 hideLoader: '&'
		},
		controller:['BaseService',controller]
	});
};

